define("ember-data/setup-container", ["exports", "@ember-data/store"], function (_exports, _store) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = setupContainer;
  0; //eaimeta@70e063a35619d71f0,"@ember-data/store"eaimeta@70e063a35619d71f
  function initializeStore(application) {
    application.registerOptionsForType('serializer', {
      singleton: false
    });
    application.registerOptionsForType('adapter', {
      singleton: false
    });
    if (!application.hasRegistration('service:store')) {
      application.register('service:store', _store.default);
    }
  }
  function setupContainer(application) {
    initializeStore(application);
  }
});